module.exports = "data:image/gif;base64,R0lGODdhEAAQANUAACdvJix0LDN6MTqAN0KIPUmQRVGXTFifUl+mWWauX2uvZGy1ZnO4bHO4bHjBcIK/fIXMe4u/h4zHh4zHh4zHh5LLjZfNk5fNk5bSjZzUlJzUlJzUlKLUnaLUnavXpavXpavXpavXpbPbrLjesdvr2vv8+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAACYALAAAAAAQABAAAAZIQJNwSCwaj8ikcmkqcZhCDASayWAcjEUCcTAUCANhdSQSeTwcTsZSqQjEGPNZza5IJIGhvcLgesECAQBEDwokUCURUIuMjY5BADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/grid/dd-insert-arrow-left.gif
 ** module id = 424
 ** module chunks = 0
 **/